import React, { useEffect, useState } from "react";
import moment from "moment";
import { FiAlertCircle, FiLock } from "react-icons/fi";
import Button from "components/atoms/Button";
import { VERSION_STATUS } from "pages/MasterPengobatanStandar/constants";

// Filter is_active untuk endpoint list (nilai dikirim sebagai query string).
export const ACTIVE_FILTERS = [
  { label: "Semua status", value: "" },
  { label: "Aktif", value: "true" },
  { label: "Nonaktif", value: "false" },
];

// Debounce ringan untuk input filter/pencarian server-side.
export const useDebounced = (value, ms = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
};

export const formatDateTime =(value) => (value ? moment(value).format("DD MMM YYYY HH:mm") : "—");

export const VersionStatusPill = ({ status }) => (
  <span className={`mps-pill is-${VERSION_STATUS[status]?.tone || "neutral"}`} title={VERSION_STATUS[status]?.hint}>
    {status}
  </span>
);

// Aktif = versi pada release terbaru (GET /version-release/active), bukan status FINAL.
export const ActivePill = () => <span className="mps-pill is-success">● Aktif</span>;

export const ErrorState = ({ messages, onRetry, title = "Gagal memuat data" }) => (
  <div className="mps-alert is-error" role="alert">
    <FiAlertCircle size={20} className="mps-alert-icon" />
    <div className="flex-grow-1">
      <p className="mps-alert-title">{title}</p>
      <ul className="mps-alert-list">
        {(messages || []).map((m) => (
          <li key={m}>{m}</li>
        ))}
      </ul>
    </div>
    {onRetry && (
      <Button type="button" variant="secondary" size="normal" onClick={onRetry}>
        Coba lagi
      </Button>
    )}
  </div>
);

// Banner untuk versi yang tidak bisa disunting (FINAL / ARCHIVE).
export const ReadOnlyBanner = ({ version, children }) => (
  <div className="mps-alert is-neutral" role="status">
    <FiLock size={18} className="mps-alert-icon" />
    <div className="flex-grow-1">
      <p className="mps-alert-title">
        Versi {version.version} berstatus {version.status} — hanya baca
      </p>
      <p className="mps-alert-text">
        Versi yang sudah dirilis beku. Untuk mengubah aturan, klon menjadi Draft baru.
      </p>
    </div>
    {children}
  </div>
);
